import { setSeenAlerts } from '../../services/seenAlerts';
import { notify } from '../../store/feedback';
import { withAlertSeen } from '../../utils/alerts';

/* Coche « vue » d'une alerte du tableau de bord des projets (bandeau de carte, fin de phase
   proche) : partagée entre managers, l'alerte revient si elle s'aggrave ou si ce qu'elle concerne
   change (15/10/2026, cf. utils/alerts). */
export default function seenAlertsHandlers(deps) {
  const { update } = deps;

  async function markAlertSeen(phase, alert) {
    const seen = withAlertSeen(phase.seenAlerts, alert);
    const { error } = await setSeenAlerts(phase.id, seen);
    if (error) return void notify("Erreur enregistrement de l'alerte vue : " + error.message);
    update((s) => ({
      ...s,
      clients: s.clients.map((c) => ({
        ...c,
        phases: c.phases.map((ph) => (ph.id === phase.id ? { ...ph, seenAlerts: seen } : ph)),
      })),
    }));
  }

  return { markAlertSeen };
}
